import * as React from 'react';
import {Comment} from '@models/comment';
import {Select, Table, Avatar, Tooltip} from 'antd';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import FormattedDateTime from "@components/custom/FormattedDateTime";
import {PaginationDefaultParams} from "@components/custom/Paginator";
import {CommentStatusOptions} from "@models/comment";
import Details from '@components/comments/Details';
import TextWithTooltip from "../custom/TextWithTooltip";


type Props = {
  data: Comment[],
  loading: boolean,
  intl: intlShape.isRequired
  currentPage: number;
  updateRequest: (item: Comment) => void;
};

const CommentsTable: React.FC<Props> = props => {
  const {data, loading, currentPage, updateRequest} = props;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;
  
  const onCommentStatus = (status, record) => {
    updateRequest({
      payload: [{
        value: status,
        path: "status",
        op: "replace",
        from: ""
      }],
      params: {
        id: record.props.recorddata.id
      },
      patch: true
    })
  };
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: 'index',
      key: 'id',
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: "",
      width: 30,
      dataIndex: 'avatar',
      key: 'avatar',
      render: (a, record) => <Avatar shape="circle"
                                     size="small"
                                     src={record.user.avatar ? record.user.avatar.path : null}
      />
    },
    {
      title: <FormattedMessage id="app.user_name" defaultMessage={`User Name`}/>,
      width: 100,
      dataIndex: 'name',
      key: 'name',
      render: (a, record: any) => <span>{record.user.name}</span>
    },
    {
      title: <FormattedMessage id="app.mobile" defaultMessage={`Mobile`}/>,
      width: 100,
      dataIndex: 'mobile',
      key: 'mobile',
      render: (a, record: any) => <span>{record.user.msisdn}</span>
    },
    {
      title: <FormattedMessage id="app.video_content_title" defaultMessage={`Video Content Title`}/>,
      width: 250,
      dataIndex: 'video_content',
      key: 'video_content',
      render: (video: any) => <span>{video.upper_title && (video.upper_title + ' - ')}{video.title}</span>
    },
    {
      title: <FormattedMessage id="app.comment" defaultMessage={`Comment`}/>,
      width: 200,
      dataIndex: 'text',
      key: 'text',
      render: (text) => {
        // Nasrin jan I'll change it
        const body = text || '';
        return (<Tooltip
          placement="top"
          title={<div className={'tooltip-tags'} dangerouslySetInnerHTML={{__html: text}}/>}>
          <div className='comment-text-wrapper'>{body.replace(/<[^>]+>/g, '')}</div>
        </Tooltip>)
      }
    },
    {
      title: <FormattedMessage id="app.creation_date" defaultMessage={`Creation Date`}/>,
      width: 120,
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => <FormattedDateTime date={date}/>
    },
    {
      title: <FormattedMessage id="app.status" defaultMessage={`Status`}/>,
      key: 'status',
      width: 30,
      dataIndex: 'status',
      render: (status, record) => (
        <Select value={record.status} className={status} onChange={onCommentStatus}>
          {CommentStatusOptions.map((opt, index) => (
            <Select.Option key={`${record.id}_${index}`} value={opt.value}
                           recorddata={record}>{opt.label}</Select.Option>
          ))}
        </Select>
      )
    },
    {
      title: <FormattedMessage id="app.more_details" defaultMessage={`More Details`}/>,
      key: 'actions',
      width: 50,
      dataIndex: 'actions',
      render: (text, record) => (
        <span className={"comment-table-more-details"}>
                    <Details comment={record}/>
                </span>
      )
    }
  ];
  return (
    <Table columns={columns}
           loading={loading}
           pagination={false}
           dataSource={data}
           rowKey='id'/>
  )
};

export default injectIntl(CommentsTable)